import React from 'react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Globe, Save } from 'lucide-react';

interface LanguageSettingsProps {
  language: string;
  timeZone: string;
  onSave: (settings: { language: string; timeZone: string }) => void;
}

export const LanguageSettings: React.FC<LanguageSettingsProps> = ({
  language,
  timeZone,
  onSave
}) => {
  const [settings, setSettings] = React.useState({
    language,
    timeZone
  });

  return (
    <Card className="p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-emerald-100 rounded-lg">
            <Globe className="w-5 h-5 text-emerald-600" />
          </div>
          <h2 className="text-lg font-semibold">Language & Region</h2>
        </div>
        <Button
          variant="primary"
          size="sm"
          icon={<Save className="w-4 h-4" />}
          onClick={() => onSave(settings)}
        >
          Save Preferences
        </Button>
      </div>

      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Language
          </label>
          <select
            value={settings.language}
            onChange={(e) => setSettings(prev => ({ ...prev, language: e.target.value }))}
            className="w-full px-3 py-2 border rounded-md focus:ring-2 focus:ring-emerald-500"
          >
            <option value="en-US">English (US)</option>
            <option value="es">Spanish</option>
            <option value="fr">French</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Time Zone
          </label>
          <select
            value={settings.timeZone}
            onChange={(e) => setSettings(prev => ({ ...prev, timeZone: e.target.value }))}
            className="w-full px-3 py-2 border rounded-md focus:ring-2 focus:ring-emerald-500"
          >
            <option value="America/Los_Angeles">Pacific Time (PT)</option>
            <option value="America/New_York">Eastern Time (ET)</option>
            <option value="Europe/London">London (GMT)</option>
            <option value="Europe/Paris">Central European Time (CET)</option>
            <option value="Asia/Tokyo">Japan (JST)</option>
          </select>
        </div>
      </div>
    </Card>
  );
};